import React from 'react';

import { cn } from '@change/ds-utils';

import { Rectangle, SkeletonContainer } from '../../../LoadingSkeletons';

import { shapes } from './body.constants';
import { BodyStyles } from './Body.styles';
import type { LoadingComponentsProps } from './types';

export function BodyLoading({ size, retryState }: LoadingComponentsProps): React.JSX.Element {
	// Disable animation when in failed retry state (static background for better contrast)
	const shouldAnimate = retryState !== 'failed';

	if (size === 'xsmall') {
		return (
			<SkeletonContainer className="h-full w-full" loading={shouldAnimate} data-testid="body-loading-root">
				<Rectangle className="h-full w-full" />
			</SkeletonContainer>
		);
	}

	return (
		<SkeletonContainer className={BodyStyles({ size })} loading={shouldAnimate} data-testid="body-loading-root">
			<div className={cn('flex flex-col', shapes.gaps[size])}>
				<div className="flex flex-row items-center justify-between">
					<div className={cn('flex flex-col', shapes.petitionInfo.petitionTitle.gaps[size])}>
						{shapes.petitionInfo.petitionTitle.rectangles.map((rect) => (
							<Rectangle key={rect.key} rounded className={rect.sizes[size]} />
						))}
					</div>
					<Rectangle className={shapes.petitionInfo.petitionImage.sizes[size]} />
				</div>
				<div className={cn('flex flex-col', shapes.message.gaps[size])}>
					{shapes.message.paragraphs.map((paragraph) => {
						return (
							<div key={paragraph.key} className={cn('flex flex-col', paragraph.gaps[size])}>
								{paragraph.rectangles.map((rect) => (
									<Rectangle key={rect.key} className={rect.sizes[size]} rounded />
								))}
							</div>
						);
					})}
					<div className={cn('flex flex-col', shapes.messageFooter.gaps[size])}>
						{shapes.messageFooter.paragraphs.map((paragraph) => {
							return (
								<div key={paragraph.key} className={cn('flex flex-col', paragraph.gaps[size])}>
									{paragraph.rectangles.map((rect) => (
										<Rectangle key={rect.key} className={rect.sizes[size]} rounded />
									))}
								</div>
							);
						})}
					</div>
				</div>
			</div>
		</SkeletonContainer>
	);
}
